import React from "react";
import type { MantineSize } from "@mantine/core";
import { Badge } from "@xplatform/design-system";
import { useTranslation } from "react-i18next";
import type { ReviewStatus } from "@models/reviews";
import { STATUS_COLOR } from "./reviewStatus";

export const ReviewStatusBadge: React.FC<{ status: ReviewStatus; size?: MantineSize }> = ({
  status,
  size = "sm",
}) => {
  const { t } = useTranslation();
  return (
    <Badge color={STATUS_COLOR[status]} variant="light" size={size}>
      {t(`reviews.status.states.${status}`)}
    </Badge>
  );
};
